import { filterMaybe } from '@edge/spark/utils'
import { breakpoints } from '../constants'
import type { Layouts } from 'react-grid-layout'
import type { DashboardCardDef } from '../types'

export const getUpdatedDashboardCards = (layouts: Layouts, cards: DashboardCardDef[]): DashboardCardDef[] => {
    const reactGridLayoutWidth = document.getElementsByClassName('react-grid-layout')[0].clientWidth

    const sortedBreakpointEntires = Object.entries(breakpoints).sort((a, b) => b[1] - a[1])

    const maybeBreakPointEntryIndex = sortedBreakpointEntires.findIndex((x) => x[1] <= reactGridLayoutWidth)

    const breakPointEntryIndex =
        maybeBreakPointEntryIndex === -1 ? sortedBreakpointEntires.length - 1 : maybeBreakPointEntryIndex

    const currentBreakpointKey = sortedBreakpointEntires[breakPointEntryIndex][0]

    const currentBreakpointLayout = layouts[currentBreakpointKey]

    const sortedLayoutCardsXY = currentBreakpointLayout.sort((a, b) => (a.y === b.y ? a.x - b.x : a.y - b.y))

    const sortedCards = sortedLayoutCardsXY
        .map((slcxy) => {
            const foundCard = cards.find((c) => slcxy.i === c.id)
            // if (!foundCard) {
            //   throw new Error(`Could not find card: ${slcxy.i}`)
            // }
            return foundCard
        })
        .filter(filterMaybe)

    return sortedCards
}
